import { defaultAxios, IParams } from './base';

export interface IFetchMonthlyRequestDetail extends IParams {
  custSeq: string;
}

export const fetchMonthlyRequestDetail = (
  params: IFetchMonthlyRequestDetail,
) => {
  return defaultAxios().post(`/loan/MonthlyRequest/detail`, params);
};
